<template>
  <div
    id="mainForm:datascrollHorizontal_content"
    class="ui-dataview-content ui-widget-content"
  >
    <div class="ui-dataview-row ui-g" title="">
      <div
        class="ui-dataview-column ui-g-12 ui-md-12 u-1/2@xs u-1/1@md ux-options-service__item"
      >
        <!-- DESKTOP -->
        <div
          id="mainForm:datascrollHorizontal:0:hotelextended:otherOption"
          class="c-extended u-border--none minisheetMASTER-30800 c-extended--accommodation c-extended--accommodation--hotel bg-clr--white u-box-shadow--soft u-border-radius--big pb-0"
          data-bathroom-count=""
          data-availposition="1"
          data-hotelname="Resort"
          data-hotel-totalprice=""
          data-hotel-showdifferenceinprices="false"
          data-destinationname=""
          data-latitude=""
          data-view-type="horizontal"
          data-longitude=""
          data-user-currency="US$"
          data-hotel-popularity=""
          data-hotel-category="3"
          data-is-apartment="false"
          data-bedroom-count=""
          data-needs-update="false"
          data-sizem2=""
          data-selected="no"
          data-code="MASTER-30800"
        >
          <div
            class="c-hover-effect__extended o-layout o-layout--stretch o-layout--gutter-default u-flex-wrap--nowrap clr--darkest-gray"
            :style="
              week.Fijado
                ? `box-shadow: 18px 18px 13px -11px rgb(255, 207, 113, 0.75);
              -webkit-box-shadow: 18px 18px 13px -11px rgb(255, 207, 113, 0.75);
              -moz-box-shadow: 18px 18px 13px -11px rgb(255, 207, 113, 0.75);`
                : ''
            "
          >
            <div
              class="c-extended__img-wrapper o-layout__item u-1/2 u-cursor--pointer"
              style="position: relative"
            >
              <div
                class="c-extended__bg-loading u-border-radius--left--big"
              ></div>
              <!-- BADGES -->
              <div class="wtype-badges" v-if="weekBadges.length">
                <span
                  v-for="b in weekBadges"
                  :key="b"
                  class="wt-chip"
                  :class="badgeClass(b)"
                  >{{ badgeLabel(b) }}</span
                >
              </div>
              <a
                id="mainForm:datascrollHorizontal:0:hotelextended:openHotel1"
                name="mainForm:datascrollHorizontal:0:hotelextended:openHotel1"
                target="_blank"
                class="dev-replace-target"
              >
                <div
                  class="c-fit-carousel c-fit-carousel--accommodation c-fit-carousel--first-position owl-carousel u-border-radius--left--big c-extended__carousel hotel-fit-carousel-mainForm:datascrollHorizontal:0:hotelextended:j_id_4py_c2 owl-carousel--no-transition owl-loaded"
                >
                  <div class="owl-stage-outer">
                    <div
                      class="owl-stage"
                      :style="{
                        display: 'flex',
                        transition: 'transform 0.4s ease',
                        transform: `translateX(-${imgActive * 100}%)`,
                      }"
                    >
                      <div
                        class="owl-item active"
                        style="flex: 0 0 100%; min-width: 100%"
                        v-for="(img, idx) in week.imgs"
                        :key="idx"
                      >
                        <div class="c-fit-carousel__item item u-1/1">
                          <!-- <div
                            class="c-hover-effect c-fit-carousel__hover-effect u-border-radius--left--big u-overflow--hidden c-hover-effect--accommodation c-hover-effect--change-color"
                          >
                            <div class="c-hover-effect__body tc-upc">
                              <div
                                class="c-hover-effect__message c-hover-effect__message--view o-group"
                              >
                                <i class="fa-regular fa-eye"></i
                                ><b> View accommodation </b>
                              </div>
                              <div
                                class="c-hover-effect__message c-hover-effect__message--select o-group"
                              >
                                <i class="fa-regular fa-check"></i
                                ><b> Select </b>
                              </div>
                            </div>
                            <div
                              class="c-hover-effect__overlaying bg-clr--overlaying"
                            ></div>
                          </div> -->
                          <span
                            id="mainForm:datascrollHorizontal:0:hotelextended:j_id_4py_c2:j_id_4py_c8:0:dev-classification-group-"
                            class="dev-classification-tag"
                          ></span>
                          <img
                            :src="img"
                            style="width: 100%; object-fit: cover"
                            data-index="0"
                            data-error-src="https://booking.vacancyrewards.com/javax.faces.resource/images/no-photo-XS.jpg"
                            onerror="this.setAttribute('data-original-url', this.src); var errorUrl = this.getAttribute('data-error-src'); if(this.src !== errorUrl) {this.src = errorUrl};"
                            loading="lazy"
                            alt="Image"
                            class="lazy-img c-fit-carousel__img c-extended__img c-extended__img--carousel u-border-radius--left--big u-overflow--hidden img-fit-cover loaded"
                            data-ll-status="loaded"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="c-fit-carousel__nav o-flexbox o-flexbox--generic-row u-align-items--stretch"
                  >
                    <button
                      @click="previousImg"
                      type="button"
                      role="presentation"
                      class="c-fit-carousel__button c-fit-carousel__button--prev fas fa-angle-left"
                    ></button
                    ><button
                      @click="nextImg"
                      type="button"
                      role="presentation"
                      class="c-fit-carousel__button c-fit-carousel__button--next fas fa-angle-right"
                    ></button>
                  </div>
                  <div class="owl-dots disabled"></div>
                </div> </a
              ><a
                class="ui-commandlink ui-widget c-extended__heart-checkbox c-heart-checkbox o-flexbox o-flexbox--generic-center"
                aria-label=""
                v-if="week.Fijado"
              >
                <input
                  type="checkbox"
                  class="c-heart-checkbox__input pp-target-checked"
                  :checked="true" />
                <span class="c-heart-checkbox__main"
                  ><i
                    class="fa-regular fa-star c-heart-checkbox__heart c-heart-checkbox__heart--off"
                  ></i
                  ><i
                    class="fa-solid fa-star c-heart-checkbox__heart"
                    style="color: #ff9d00"
                  ></i></span
              ></a>
            </div>
            <div
              class="c-extended__main o-box o-layout__item o-flexbox--generic-column u-flex--11 u-cursor--pointer"
              style="position: relative"
            >
              <div
                class="c-extended__price c-price u-text-align--right u-white-space--nowrap"
                style="position: absolute; top: 16px; right: 18px; z-index: 5"
              >
                <div class="c-price__bottom u-font-size--small u-line-height--175">
                  {{ $func.parseIso("fromPrice") }}
                </div>
                <div
                  class="c-price__primary u-font-size--huge u-line-height--1 clr--price-difference clr--price-difference--neutral"
                >
                  $ {{ minPrice }} USD
                </div>
              </div>
              <div
                class="u-display--flex u-flex-direction--column u-flex-direction--row@lg u-justify-content--between@lg u-height--100 u-gap--tiny u-gap--default@lg"
              >
                <div
                  class="o-flexbox o-flexbox--generic-column u-justify-content--start u-gap--tiny u-min-width--auto"
                >
                  <div class="c-extended__heading">
                    <a
                      id="mainForm:datascrollHorizontal:0:hotelextended:openHotel2"
                      name="mainForm:datascrollHorizontal:0:hotelextended:openHotel2"
                      class="o-block o-block--tiny dev-replace-target"
                      @click="goResort"
                    >
                      <b
                        class="c-extended__title o-block__item u-display--block u-font-size--middle dev-hotel-title"
                      >
                        {{ week.ResortName }}

                        <span
                          class="c-hotel-status__category u-vertical-align--middle u-white-space--nowrap null"
                          style="visibility: hidden"
                          ><i class="fa-solid fa-star c-hotel-status__star"></i
                          ><i class="fa-solid fa-star c-hotel-status__star"></i
                          ><i class="fa-solid fa-star c-hotel-status__star"></i
                          ><i
                            class="fa-solid fa-star c-hotel-status__star hidden"
                          ></i
                          ><i
                            class="fa-solid fa-star c-hotel-status__star hidden"
                          ></i
                          ><i
                            class="fa-solid fa-star c-hotel-status__star hidden"
                          ></i
                        ></span>
                      </b>
                      <div class="">
                        <span
                          class="c-rating c-rating-- u-font-weight--700 c-rating--reverse@lg"
                        >
                          <span
                            class="c-rating__score u-border-radius u-line-height--1"
                            :style="{ backgroundColor: getRatingInfo(ratingScore).color }"
                          >
                            {{ ratingValue }} </span
                          ><span
                            class="o-flexbox o-flexbox--generic-column u-min-width--auto"
                            ><span
                              class="c-rating__grade u-line-height--1 u-white-space--nowrap"
                              :style="{ color: getRatingInfo(ratingScore).color }"
                            >
                              {{ $func.parseIso(getRatingInfo(ratingScore).text) }} </span
                            ><span
                              class="u-font-size--small u-text-decoration--underline u-font-weight--400 clr--middle-gray u-hide-empty"
                            ></span></span
                        ></span>
                      </div>
                    </a>
                  </div>
                  <b
                    id="c-extended__distance--MASTER-30800"
                    class="c-extended__distance o-block__item u-font-size--small clr--darkest-gray interest-name u-white-space--initial"
                    ><a
                      id="mainForm:datascrollHorizontal:0:hotelextended:hotelMap"
                      name="mainForm:datascrollHorizontal:0:hotelextended:hotelMap"
                      class="c-inline-link"
                    >
                      {{ formatDate(week.CheckInDate) }} -
                      {{ formatDate(week.CheckOutDate) }}
                    </a>
                  </b>
                  <b
                    id="c-extended__distance--MASTER-30800"
                    class="c-extended__distance o-block__item u-font-size--small clr--darkest-gray interest-name u-white-space--initial"
                    ><a
                      id="mainForm:datascrollHorizontal:0:hotelextended:hotelMap"
                      name="mainForm:datascrollHorizontal:0:hotelextended:hotelMap"
                      class="c-inline-link"
                    >
                      {{ week.ResortAddress1 || ""
                      }}{{
                        week.ResortAddress2 ? `, ${week.ResortAddress2}` : ""
                      }}{{
                        week.ResortAddress3 ? `, ${week.ResortAddress3}` : ""
                      }}
                    </a>
                  </b>
                  <a
                    id="mainForm:datascrollHorizontal:0:hotelextended:openHotel4"
                    name="mainForm:datascrollHorizontal:0:hotelextended:openHotel4"
                    class="o-block__item o-block o-block--tiny dev-replace-target"
                    @click="goResort"
                  >
                    <!-- AMENITIES -->
                    <div class="ri-amenities" v-if="displayAmenities.length">
                      <span
                        class="amen"
                        v-for="(a, i) in displayAmenities"
                        :key="i"
                      >
                        <i :class="amenIcon(a.name)"></i>{{ a.name }}
                      </span>
                    </div>
                    <div
                      class="c-extended__selected-combination o-block__item u-font-size--small"
                    >
                      <div
                        class="u-display--flex u-gap--tiny u-flex-wrap--wrap o-group o-group--small"
                      >
                        <span
                          ><i class="fa-regular fa-utensils fa-fw"></i>
                          {{ week.KitchenType }}
                        </span>
                        <span
                          ><i class="fa-regular fa-bed fa-fw"></i>
                          {{ week.UnitType }}
                        </span>
                        <span
                          ><i class="fa-regular fa-users fa-fw"></i>
                          {{ week.MaxOccupancy }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="c-extended__description u-font-size--small@lg u-font-size--default@xl o-block__item clr--dark-gray"
                    >
                      {{ parseDescription() }}
                    </div>
                  </a>
                </div>
                 </div>
              </div>
            </div>
          </div>
          <!-- UNITS BAR -->
          <div class="units-bar" v-if="weekUnits.length && isDesktop">
            <span class="units-count"
              >{{ weekUnits.length }}
              {{ $func.parseIso("unitsAvailable") }}</span
            >
            <div class="units-pills">
              <div
                class="upill"
                v-for="(u, i) in weekUnits.slice(0, 3)"
                :key="u._id || i"
              >
                <span
                  class="up-wt"
                  :class="wtDotClass(u.InvTypeInDetail)"
                ></span>
                {{ u.UnitType }} · {{ u.KitchenType }} ·
                {{ u.MaxOccupancy }} guests
                <span class="up-price">${{ u.Cost }}</span>
              </div>
              <div class="upill" v-if="weekUnits.length > 3">
                <span>+{{ weekUnits.length - 3 }} more</span>
              </div>
            </div>
            <button class="see-units-btn" @click="goResort">
              {{ $func.parseIso("seeAvailableUnits") }}
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                width="12"
                height="12"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </button>
          </div>
        </div>
        <!-- MOBILE -->
        <div
          id="mainForm:datascrollHorizontal:0:hotelcard:hotelCard"
          class="c-card u-box-shadow--soft u-border-radius--big bg-clr--white u-border--none c-card--accommodation c-card--accommodation--hotel pp-target-hotel minisheetMASTER-30800 pi-col-link pi-right pp-bar c-card--vertical-flex o-layout--stretch mb-20 c-hover-effect__wrapper"
          data-user-currency="US$"
          data-availposition="1"
          data-hotelname="Resort"
          data-hotel-totalprice=""
          data-hotel-showdifferenceinprices="false"
          data-hotel-popularity=""
          data-hotel-category="3"
          data-destinationname=""
          data-latitude=""
          data-view-type="miniFicha"
          data-longitude=""
          data-code="MASTER-30800"
        >
          <div class="c-card__main clr--darkest-gray">
            <div
              class="c-card__hero u-border-radius--none u-border-radius--top--big u-cursor--pointer"
              style="position: relative"
            >
              <div class="c-card__top">
                <div class="c-card__price c-price">
                  <b
                    class="c-price__primary u-white-space--nowrap u-font-size--big price-tooltip clr--price-difference clr--price-difference--neutral"
                    data-toggle="tooltip"
                    data-placement="right"
                    title=""
                  >
                    $ {{ minPrice }} USD
                  </b>
                  <div class="c-price__bottom u-font-size--small">
                    {{ $func.parseIso("fromPrice") }}
                  </div>
                </div>
              </div>
              <!-- BADGES -->
              <div class="wtype-badges" v-if="weekBadges.length">
                <span
                  v-for="b in weekBadges"
                  :key="b"
                  class="wt-chip"
                  :class="badgeClass(b)"
                  >{{ badgeLabel(b) }}</span
                >
              </div>
              <a
                id="mainForm:datascrollHorizontal:0:hotelcard:toggleFavourite"
                class="ui-commandlink ui-widget c-card__heart-checkbox c-heart-checkbox o-flexbox o-flexbox--generic-center"
                aria-label=""
                v-if="week.Fijado"
              >
                <input
                  type="checkbox"
                  class="c-heart-checkbox__input pp-target-unchecked" />
                <span class="c-heart-checkbox__main"
                  ><i
                    class="fa-regular fa-star c-heart-checkbox__heart c-heart-checkbox__heart--off"
                  ></i
                  ><i
                    class="fa-solid fa-star c-heart-checkbox__heart"
                    style="color: #ff9d00"
                  ></i></span></a
              ><a
                id="mainForm:datascrollHorizontal:0:hotelcard:toggleHolidayPackagePreferredAccommodation"
                class="ui-commandlink ui-widget c-extended__heart-checkbox c-heart-checkbox o-flexbox o-flexbox--generic-center c-heart-checkbox--package"
                aria-label=""
                style="visibility: hidden"
              >
                <input
                  type="checkbox"
                  class="c-heart-checkbox__input pp-target-unchecked" />
                <span
                  class="c-heart-checkbox__main tc-tooltip"
                  title="The selected acomodations will be the only ones available for your holiday package"
                  ><i
                    class="fa-lg fa-solid fa-circle-plus clr--white"
                  ></i> </span></a
              ><a
                id="mainForm:datascrollHorizontal:0:hotelcard:openHotelCard1"
                name="mainForm:datascrollHorizontal:0:hotelcard:openHotelCard1"
                class="dev-replace-target"
              >
                <div
                  class="c-fit-carousel c-fit-carousel--accommodation c-fit-carousel--first-position owl-carousel u-border-radius--left--big c-card__carousel u-border-radius--top--big hotel-fit-carousel-mainForm:datascrollHorizontal:0:hotelcard:j_id_4py_ij owl-carousel--no-transition owl-loaded"
                >
                  <div class="owl-stage-outer">
                    <div
                      class="owl-stage"
                      :style="{
                        display: 'flex',
                        transition: 'transform 0.4s ease',
                        transform: `translateX(-${imgActive * 100}%)`,
                      }"
                    >
                      <div
                        class="owl-item"
                        style="flex: 0 0 100%; min-width: 100%"
                        v-for="(img, idx) in week.imgs"
                        :key="idx"
                      >
                        <div class="c-fit-carousel__item item u-1/1">
                          <!-- <div
                            class="c-hover-effect c-fit-carousel__hover-effect u-border-radius--left--big u-overflow--hidden c-hover-effect--accommodation c-hover-effect--change-color"
                          >
                            <div class="c-hover-effect__body tc-upc">
                              <div
                                class="c-hover-effect__message c-hover-effect__message--view o-group"
                              >
                                <i class="fa-regular fa-eye"></i
                                ><b> View accommodation </b>
                              </div>
                              <div
                                class="c-hover-effect__message c-hover-effect__message--select o-group"
                              >
                                <i class="fa-regular fa-check"></i
                                ><b> Select </b>
                              </div>
                            </div>
                            <div
                              class="c-hover-effect__overlaying bg-clr--overlaying"
                            ></div>
                          </div> -->
                          <span
                            id="mainForm:datascrollHorizontal:0:hotelcard:j_id_4py_ij:j_id_4py_ip:0:dev-classification-group-"
                            class="dev-classification-tag"
                          ></span>
                          <img
                            id="img-resort"
                            :src="img"
                            data-index="0"
                            data-error-src="https://booking.vacancyrewards.com/javax.faces.resource/images/no-photo-XS.jpg"
                            onerror="this.setAttribute('data-original-url', this.src); var errorUrl = this.getAttribute('data-error-src'); if(this.src !== errorUrl) {this.src = errorUrl};"
                            loading="lazy"
                            alt="Image"
                            width=""
                            height=""
                            onclick=""
                            style="object-fit: cover"
                            class="lazy-img c-fit-carousel__img img-fit-cover loaded"
                            data-ll-status="loaded"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="c-fit-carousel__nav o-flexbox o-flexbox--generic-row u-align-items--stretch"
                  >
                    <button
                      @click="previousImg"
                      type="button"
                      role="presentation"
                      class="c-fit-carousel__button c-fit-carousel__button--prev fas fa-angle-left"
                    ></button
                    ><button
                      @click="nextImg"
                      type="button"
                      role="presentation"
                      class="c-fit-carousel__button c-fit-carousel__button--next fas fa-angle-right"
                    ></button>
                  </div>
                  <div class="owl-dots disabled"></div>
                </div>
              </a>
            </div>
            <div class="o-box--small pb-5 o-block o-block--tiny">
              <a
                id="mainForm:datascrollHorizontal:0:hotelcard:openHotelCard2"
                name="mainForm:datascrollHorizontal:0:hotelcard:openHotelCard2"
                class="c-card__body selected-combination u-cursor--pointer dev-replace-target"
              >
                <div
                  class="o-flexbox o-flexbox--generic-row u-align-items--start u-gap--small"
                >
                  <div
                    class="c-card__wrapper-title o-block__item"
                    style="margin-bottom: -20px"
                  >
                    <b
                      class="c-card__title hotel-name dev-hotel-title u-ellipsis-block u-ellipsis-block--two-lines u-line-height--125"
                    >
                      {{ week.ResortName }}
                    </b>
                    <span
                      class="c-hotel-status__category u-vertical-align--middle u-white-space--nowrap u-display--block"
                      style="visibility: hidden"
                      ><i class="fa-solid fa-star c-hotel-status__star"></i
                      ><i class="fa-solid fa-star c-hotel-status__star"></i
                      ><i class="fa-solid fa-star c-hotel-status__star"></i
                      ><i
                        class="fa-solid fa-star c-hotel-status__star hidden"
                      ></i
                      ><i
                        class="fa-solid fa-star c-hotel-status__star hidden"
                      ></i
                      ><i
                        class="fa-solid fa-star c-hotel-status__star hidden"
                      ></i
                    ></span>
                  </div>
                  <span
                    class="c-rating c-rating--sm u-font-weight--700 c-rating--reverse"
                    style="visibility: hidden"
                  >
                    <span
                      class="c-rating__score u-border-radius u-line-height--1"
                      :style="{ backgroundColor: getRatingInfo(ratingScore).color }"
                    >
                      {{ ratingValue }} </span
                    ><span
                      class="o-flexbox o-flexbox--generic-column u-min-width--auto"
                      ><span
                        class="c-rating__grade u-line-height--1 u-white-space--nowrap"
                        :style="{ color: getRatingInfo(ratingScore).color }"
                      >
                        {{ $func.parseIso(getRatingInfo(ratingScore).text) }} </span
                      ><span
                        class="u-font-size--small u-text-decoration--underline u-font-weight--400 clr--middle-gray u-hide-empty"
                      ></span></span
                  ></span>
                </div>
                <b
                  id="c-extended__distance--MASTER-30800"
                  class="c-extended__distance o-block__item u-font-size--small clr--darkest-gray interest-name u-white-space--initial mt-5"
                ></b> </a
              ><b
                id="c-extended__distance--MASTER-30800"
                class="c-extended__distance o-block__item u-font-size--small clr--darkest-gray interest-name u-white-space--initial mt-5"
                ><a
                  id="mainForm:datascrollHorizontal:0:hotelcard:hotelMap"
                  name="mainForm:datascrollHorizontal:0:hotelcard:hotelMap"
                  class="c-inline-link dev-hotelMap"
                >
                  {{ formatDate(week.CheckInDate) }} -
                  {{ formatDate(week.CheckOutDate) }}
                </a></b
              >
              <b
                id="c-extended__distance--MASTER-30800"
                class="c-extended__distance o-block__item u-font-size--small clr--darkest-gray interest-name u-white-space--initial mt-5"
                ><a
                  id="mainForm:datascrollHorizontal:0:hotelcard:hotelMap"
                  name="mainForm:datascrollHorizontal:0:hotelcard:hotelMap"
                  class="c-inline-link dev-hotelMap"
                >
                  {{ week.ResortAddress1 || ""
                  }}{{ week.ResortAddress2 ? `, ${week.ResortAddress2}` : ""
                  }}{{ week.ResortAddress3 ? `, ${week.ResortAddress3}` : "" }}
                </a></b
              >
              <!-- AMENITIES -->
              <div class="ri-amenities" v-if="displayAmenities.length">
                <span
                  class="amen"
                  v-for="(a, i) in displayAmenities"
                  :key="i"
                >
                  <i :class="amenIcon(a.name)"></i>{{ a.name }}
                </span>
              </div>
              <div class="o-block__item c-card__detail u-font-size--small">
                <i class="fa-regular fa-bed-alt"></i
                ><span>
                  {{ week.UnitType }}
                </span>
              </div>
              <div class="o-block__item c-card__detail u-font-size--small">
                <i class="fa-regular fa-utensils"></i
                ><span>{{ week.KitchenType }}</span>
              </div>
              <div class="o-block__item c-card__detail u-font-size--small">
                <i class="fa-regular fa-users"></i
                ><span>{{ week.MaxOccupancy }}</span>
              </div>
            </div>
          </div>
          <!-- UNITS BAR -->
          <div class="units-bar" v-if="weekUnits.length">
            <span class="units-count"
              >{{ weekUnits.length }}
              {{ $func.parseIso("unitsAvailable") }}</span
            >
            <div class="units-pills">
              <div
                class="upill"
                v-for="(u, i) in weekUnits.slice(0, 1)"
                :key="u._id || i"
              >
                <span
                  class="up-wt"
                  :class="wtDotClass(u.InvTypeInDetail)"
                ></span>
                {{ u.UnitType }} · {{ u.KitchenType }} ·
                {{ u.MaxOccupancy }} guests
                <span class="up-price">${{ u.Cost }}</span>
              </div>
              <div class="upill" v-if="weekUnits.length > 1">
                <span>+{{ weekUnits.length - 1 }} more</span>
              </div>
            </div>
            <button class="see-units-btn" @click="goResort">
              {{ $func.parseIso("seeAvailableUnits") }}
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                width="12"
                height="12"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setWeekObject } from "../../utils/sesions";
export default {
  data() {
    return {
      iso: null,
      imgActive: 0,
      isDesktop:
        typeof window !== "undefined" ? window.innerWidth >= 768 : true,
    };
  },
  props: ["week", "token"],
  computed: {
    weekUnits() {
      return Array.isArray(this.week?.units) ? this.week.units : [];
    },
    weekBadges() {
      const arr =
        Array.isArray(this.week?.units) && this.week.units.length
          ? this.week.units.map((u) => u.InvTypeInDetail)
          : [this.week?.InvTypeInDetail];
      return [...new Set(arr.filter(Boolean))];
    },
    minPrice() {
      return this.week?.Cost ?? 0;
    },
    displayAmenities() {
      const amenities = this.week?.Amenities || [];
      return amenities
        .filter(
          (a) => a.proximity === "Onsite" || a.proximity === "Yes",
        )
        .slice(0, 3);
    },
    ratingScore() {
      const r = parseFloat(this.week?.Rating) || 0;
      return Math.round(r);
    },
    ratingValue() {
      const r = parseFloat(this.week?.Rating) || 0;
      return parseFloat(r.toFixed(1));
    },
  },
  created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
      this.$forceUpdate();
    });
  },
  mounted() {
    (this.week?.imgs || []).forEach((src) => {
      const img = new Image();
      img.src = src;
    });
    this._onResize = () => {
      this.isDesktop = window.innerWidth >= 768;
    };
    window.addEventListener("resize", this._onResize);
  },
  beforeDestroy() {
    if (this._onResize) window.removeEventListener("resize", this._onResize);
  },
  methods: {
    getRatingInfo(code) {
      const info = {
        0: { text: "rating0", color: "#94A3B8" },
        1: { text: "rating1", color: "#F87171" },
        2: { text: "rating2", color: "#FB923C" },
        3: { text: "rating3", color: "#FACC15" },
        4: { text: "rating4", color: "#A3E635" },
        5: { text: "rating5", color: "#10B981" },
      };
      return info[code] || info[0];
    },
    badgeClass(type) {
      const t = (type || "").toLowerCase();
      if (t.includes("last minute")) return "wt-lmw";
      if (t.includes("smart")) return "wt-smart";
      if (t.includes("vip")) return "wt-vip";
      return "";
    },
    badgeLabel(type) {
      const t = (type || "").toLowerCase();
      if (t.includes("last minute")) return "Last Minute";
      if (t.includes("smart")) return "Smart Week";
      if (t.includes("vip")) return "VIP Week";
      return type;
    },
    wtDotClass(type) {
      const t = (type || "").toLowerCase();
      if (t.includes("last minute")) return "lm";
      if (t.includes("smart")) return "sm";
      if (t.includes("vip")) return "vip";
      return "";
    },
    amenIcon(name) {
      const n = (name || "").toLowerCase();
      const map = [
        [/pool|swimming/, "fa-regular fa-water-ladder"],
        [/hot tub/, "fa-regular fa-hot-tub-person"],
        [/spa/, "fa-regular fa-spa"],
        [/fitness/, "fa-solid fa-dumbbell"],
        [/tennis/, "fa-solid fa-baseball-ball"],
        [/restaurant|bar\/lounge|bar/, "fa-regular fa-utensils"],
        [/game room/, "fa-solid fa-gamepad"],
        [/playground|children/, "fa-solid fa-child"],
        [/business center/, "fa-solid fa-briefcase"],
        [/concierge/, "fa-regular fa-bell-concierge"],
        [/golf/, "fa-solid fa-golf-ball-tee"],
        [/elevator/, "fa-solid fa-elevator"],
        [/internet|wi.?fi/, "fa-solid fa-wifi"],
        [/laundry/, "fa-solid fa-soap"],
        [/parking/, "fa-solid fa-square-parking"],
        [/atm|banking/, "fa-regular fa-money-bill"],
        [/marina/, "fa-solid fa-anchor"],
        [/movie/, "fa-solid fa-film"],
        [/nightclub/, "fa-solid fa-music"],
        [/safe/, "fa-solid fa-lock"],
        [/sauna/, "fa-regular fa-heat"],
        [/steam/, "fa-regular fa-heat"],
        [/shuttle/, "fa-solid fa-bus"],
        [/television|tv/, "fa-solid fa-tv"],
        [/wheelchair|accessible/, "fa-solid fa-wheelchair"],
        [/billiards|pool table/, "fa-solid fa-circle-dot"],
        [/car rental/, "fa-solid fa-car"],
        [/conference/, "fa-solid fa-chalkboard-user"],
        [/gift shop|newsstand/, "fa-solid fa-bag-shopping"],
        [/grocery/, "fa-solid fa-cart-shopping"],
        [/medical/, "fa-solid fa-suitcase-medical"],
        [/multilingual/, "fa-solid fa-language"],
      ];
      for (const [re, icon] of map) {
        if (re.test(n)) return icon;
      }
      return "fa-regular fa-circle-info";
    },
    parseDescription() {
      if (this.week) {
        const { HighlightsEN, HighlightsSP } = this.week;
        let description = this.iso === "en" ? HighlightsEN : HighlightsSP;
        if (!description) description = this.week.ResortHighLights;
        if (!description) return this.$func.parseIso("loadingDescription") + "...";

        return description.length > 250
          ? `${description.substring(0, 250)} ...`
          : description;
      }
      return this.$func.parseIso("loadingDescription") + "...";
    },
    nextImg() {
      if (this.imgActive < this.week.imgs.length - 1) this.imgActive++;
    },
    previousImg() {
      if (this.imgActive > 0) this.imgActive--;
    },
    goResort() {
      this.$router.push(
        `/resort?weekId=${this.week._id}&weekInventoryId=${this.week.InventoryID}`,
      );
      // this.$router.push(`/resort?token=${this.token}&weekId=${this.week._id}`);
    },
    formatDate(date) {
      if (!date) return "";
      return this.$moment(date).format("LL");
    },
  },
};
</script>

<style scoped>
.ux-options-service__item {
  margin-bottom: 28px;
}

.ux-options-service__item .c-extended,
.ux-options-service__item .c-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
.ux-options-service__item:hover .c-extended,
.ux-options-service__item:hover .c-card {
  transform: translateY(-3px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
}

.c-hover-effect:hover .c-hover-effect__overlaying,
.c-extended__img-wrapper:hover .c-hover-effect__overlaying,
.c-hover-effect__wrapper:hover .c-hover-effect__overlaying,
.c-hover-effect__wrapper.c-hover-effect--active .c-hover-effect__overlaying,
.c-hover-effect--active .c-hover-effect__overlaying {
  background-color: rgba(57, 57, 57, 0.3) !important;
}

.owl-stage-outer {
  overflow: hidden;
}

#img-resort {
  @media (max-width: 767px) {
    width: 400px;
  }
}

/* Badges sobre la imagen */
.wtype-badges {
  position: absolute;
  top: 10px;
  left: 30px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 5;
}
.wt-chip {
  padding: 3px 9px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.wt-lmw {
  background: #FF4081;
}
.wt-smart {
  background: #59AC77;
}
.wt-vip {
  background: #4647AE;
}

/* Amenidades */
.ri-amenities {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding: 4px 0;
}
.ri-amenities .amen {
  font-size: 11.5px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 4px;
}
.ri-amenities .amen i {
  font-size: 11px;
}

/* Units bar */
.units-bar {
  background: #f7f8fa;
  border-top: 1px solid #dde3ea;
  padding: 12px 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.units-count {
  font-size: 12px;
  font-weight: 700;
  color: #00527c;
  white-space: nowrap;
}
.units-pills {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  flex: 1;
}
.upill {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  background: #fff;
  border: 1.5px solid #dde3ea;
  border-radius: 6px;
  font-size: 11px;
  color: #6b7280;
  font-weight: 500;
}
.upill .up-price {
  font-weight: 700;
  color: #1a1a2e;
  margin-left: 2px;
}
.upill .up-wt {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.upill .up-wt.lm {
  background: #FF4081;
}
.upill .up-wt.sm {
  background: #59AC77;
}
.upill .up-wt.vip {
  background: #4647AE;
}
.see-units-btn {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  background: #0472aa;
  color: #fff;
  border: none;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
  flex-shrink: 0;
}
.see-units-btn:hover {
  background: #00527c;
}

.c-extended {
  display: block;
}
.c-card.c-card--accommodation--hotel {
  display: none;
}

@media (max-width: 767px) {
  .units-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .see-units-btn {
    margin-left: 0;
    width: 100%;
    justify-content: center;
  }
  .c-extended {
    display: none;
  }
  .c-card.c-card--accommodation--hotel {
    display: block;
  }
}
</style>